"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var check_1 = tslib_1.__importDefault(require("./check"));
var CheckRunResource = /** @class */ (function (_super) {
    tslib_1.__extends(CheckRunResource, _super);
    function CheckRunResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckRunResource.endpoint = '/runs';
    CheckRunResource.MODEL_NAME = 'checkrun';
    CheckRunResource.related = {
        checks: check_1.default,
    };
    return CheckRunResource;
}(base_1.default));
exports.default = CheckRunResource;
//# sourceMappingURL=checkrun.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/checkrun.js
// module id = D+T+
// module chunks = 0